<template>
  <v-app>
    <v-container>
      <v-form @submit.prevent="saveImages" class="shadow p-2">
        <v-alert border="top" color="#0D47A1" dark block>
          Add images to carousel
        </v-alert>

        <div class="form-group">
          <label for="group-image">Update Images</label>
          <input
            type="file"
            @change="uploadFieldChange"
            multiple="multiple"
            name="image"
            class="form-control"
            accept="image/png, image/jpeg"
          />
        </div>

        <v-btn type="submit" class="text-white" small color="#1E88E5"
          >Save</v-btn
        >
      </v-form>

      <div class="col-md-12">
        <v-carousel>
          <v-carousel-item
            v-for="item in items"
            :key="item.id"
            :src="item.image_path"
            reverse-transition="fade-transition"
            transition="fade-transition"
          >
            <v-btn class="mx-2 text-white" fab dark color="#0D47A1">
              {{ item.id }}
            </v-btn>
          </v-carousel-item>
        </v-carousel>
      </div>

      <div class="d-flex flex-row">
        <div class="col-md-12 p-2">
          <v-alert border="top" color="#0D47A1" dark block>
            Change or Delete actual Images
          </v-alert>

          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th>Image Number</th>
                  <th>Actions</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in items" :key="item.name">
                  <td class="text-dark">{{ item.id }}</td>
                  <td>
                    <v-form @submit.prevent="newImage(item)" class="card p-2">
                      <div class="form-group">
                        <label for="group-image">Update Images</label>
                        <input
                          type="file"
                          @change="changeImage"
                          name="image"
                          class="form-control"
                          accept="image/png, image/jpeg"
                        />
                      </div>

                      <v-btn
                        type="submit"
                        class="text-white"
                        small
                        color="#1E88E5"
                        >Update</v-btn
                      >
                    </v-form>
                  </td>
                  <td>
                    <v-btn
                      @click="deleteImage(item)"
                      class="text-white"
                      small
                      color="#B71C1C"
                      >Delete</v-btn
                    >
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </div>
    </v-container>
  </v-app>
</template>
<script
  src="https://code.jquery.com/jquery-3.5.1.slim.min.js"
  integrity="sha384-DfXdz2htPH0lsSSs5nCTpuj/zy4C+OGpamoFVy38MVBnE+IbbVYUew+OrCXaRkfj"
  crossorigin="anonymous"
></script>

<script>
import Swal from "sweetalert2";
export default {
  props: ["items", "inventoryId"],
  data: () => ({
    idItem: "",
    image: [],
    imageChange: []
  }),

  methods: {
    changeImage(e) {
      this.imageChange = e.target.files || e.dataTransfer.files;
    },

    newImage(item) {
      var config = {
        headers: {
          "Content-Type": "multipart/form-data"
        },
        onUploadProgress: function(progressEvent) {
          this.percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          this.$forceUpdate();
        }.bind(this)
      };

      let imageData = new FormData();

      $.each(this.imageChange, function(key, image) {
        imageData.append(`image[${key}]`, image);
        imageData.append("imgId", item.id);
      });

      window.axios.post("/api/imageUpdate", imageData, config).then(() => {
        this.$emit("event");
        Swal.fire("Updated!", "Your Image has been updated.", "success");
      });
    },

    uploadFieldChange(e) {
      this.image = e.target.files || e.dataTransfer.files;
    },

    deleteImage(item) {
      Swal.fire({
        title: "Are you sure?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
      }).then(result => {
        if (result.value) {
          window.axios.patch("/api/gallery/" + item.id).then(() => {
            this.$emit("event");
            Swal.fire("Deleted!", "Your Image has been deleted.", "success");
          });
        }
      });
    },

    saveImages() {
      var config = {
        headers: {
          "Content-Type": "multipart/form-data"
        },
        onUploadProgress: function(progressEvent) {
          this.percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          this.$forceUpdate();
        }.bind(this)
      };

      let formData = new FormData();

      $.each(this.image, function(key, image) {
        formData.append(`images[${key}]`, image);
      });

      formData.append("invId", this.inventoryId);

      window.axios.post("/api/addImage", formData, config).then(() => {
        this.$emit("event");
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Images Added successfully",
          showConfirmButton: false,
          timer: 1500
        });
      });
    }
  }
};
</script>
<style scoped>
.fileInput {
  color: #444444;
  outline: none;
  background-color: transparent;
  border-color: none;
}
</style>
